import React from "react";
import Moment from "react-moment";
import { Box, Grid, Typography } from "@mui/material";

interface Props {
  field: string;
  value: any;
  isDateField?: boolean;
}

export const CardItem = ({ field, value, isDateField = false }: Props) => {
  return (
    <Grid container item direction="row" xs={6}>
      <Grid item xs={5}>
        <Box color="text.secondary">
          <Typography>{`${field}: `}</Typography>
        </Box>
      </Grid>
      <Grid item xs={5}>
        <Box color="text.primary">
          {isDateField && Boolean(value) ? (
            <Typography>
              <Moment local={true} format="MM/DD/YYYY hh:mm A" date={value} />
            </Typography>
          ) : (
            <Typography>{value}</Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
